export enum CowStatusMessage {
  Open = 'Order Placed',
  Fulfilled = 'Order Fulfilled',
  Cancelled = 'Order Cancelled',
  Expired = 'Order Expired',
}
